<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

            <div class="col-12">
                <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Laporan Kartu Stok</h5>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="createLapStok()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tanggal</label>
                            <datepicker v-model="akhir" class="form-controlx" :disabledDates="disabledAkhir" name="akhir" :format="format" placeholder="Stok Tanggal"></datepicker>
                        </div>
                        <!--div class="form-group">
                            <label>Tahun : </label>
                            <input v-model.number="tahun" type="number" min="2022" />
                            <has-error :form="form" field="tanggal"></has-error>
                        </div-->
                        <div class="form-group">
                            <label>Sumber Dana</label>
                            <select v-model="sd" name="sumber_dana_id" @change="loadBarangs" class="form-control" :class="{ 'is-invalid': form.errors.has('Sumber Dana') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="sumberdana in sumberdanas" :value="sumberdana.id">
                                {{ sumberdana.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="sumber_dana_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Nama Barang</label>
                            <v-select :options="barangs" :reduce="(barang) => barang.barang_id"
                                        label="nama_barang"
                                        v-model="barang_id"
                            >
                                <template #option="{ nama_barang, satuan, keterangan, stok, barang_id }">
                                    {{ nama_barang }} | Stok {{ stok }} {{ satuan }} | {{ keterangan }}
                                </template>
                            </v-select>
                            <has-error :form="form" field="barang_id"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!--button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button-->
                        <button type="submit" class="btn btn-success fas fa-file-excel"> Ekspor</button>
                    </div>
                  </form>
                </div>
            </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        data () {
            return {
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                format: 'yyyy-MM-dd',
                editmode: false,
                barangs : [],
                sumberdanas : {},
                barang_id : '',
                sd : '',
                tahun: '',
                akhir:'',
                form: new Form({
                    id : ''                    
                })
            }
        },
        methods: {            
            createLapStok() {
				let tahun = this.akhir.getFullYear();

				let yyyy = this.akhir.getFullYear();
				let mm = String(this.akhir.getMonth() + 1).padStart(2, '0');
				let dd = String(this.akhir.getDate()).padStart(2, '0');

				let tanggal = `${yyyy}-${mm}-${dd}`;

				axios.get('api/lapkartustokxls', {
					params: {
						tahun: tahun,
						akhir: tanggal,
						sd: this.sd,
						bid: this.barang_id
					},
					responseType: 'blob'
				}).then(response => {
					const fileURL = window.URL.createObjectURL(new Blob([response.data]));
					const fileLink = document.createElement('a');
					fileLink.href = fileURL;
					fileLink.setAttribute('download', `kartustok-${tahun}.xlsx`);
					document.body.appendChild(fileLink);
					fileLink.click();
				});
			},
            loadBarangs(event){
				if (!this.akhir) return;

				let tahun = this.akhir.getFullYear();

				axios.get("/api/barang/tstok", {
					params: {
						tahun: tahun,
						sd: event.target.value
					}
				}).then(({ data }) => {
					this.barangs = data.data;
				});
			},
            loadSumberDana(){
                axios.get("/api/sumber_dana/objlist").then(({ data }) => (this.sumberdanas = data.data));
            }
            
        },
        mounted() {
            this.tahun= new Date().getFullYear();
            //this.loadBarangs();
            this.loadSumberDana();
            console.log('Component mounted.');
        },
        created() {
            
        },
        components: {
            Datepicker
        }
    }
</script>